import { render } from "./AboutPage.vue?vue&type=template&id=5368ff23&scoped=true"
import script from "./AboutPage.vue?vue&type=script&lang=js"
export * from "./AboutPage.vue?vue&type=script&lang=js"

import "./AboutPage.vue?vue&type=style&index=0&id=5368ff23&lang=scss&scoped=true"

import exportComponent from "/Users/elodie/Desktop/Dev/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5368ff23"]])

export default __exports__